import { Column, Filter } from '@nirvana/shared/dtos/types/shared/filters';
import { GridColumnConfiguration } from '@nirvana/shared/dtos/types/shared/grid';

export interface GetAllColumnDetailsRequest {
  targetId: string;
  locale: string;
}

export enum ViewType {
  DEFAULT = 0,
  CUSTOM = 1,
}

export enum DefaultViewIds {
  GENERAL = '5ef09b3515369f4614821662',
  HYBRID = '5ef09b3515369f4614821663',
  POLICY = '5ef09b3515369f4614821664',
  DEVICE_CONTROL = '5ef09b3515369f4614821665',
}

export enum ColumnType {
  DATE = 0,
  ENUM = 1,
  STRING = 2,
  NUMBER = 3,
  COMPANY = 6,
  TAGS = 12,
}

export interface Target {
  companyId: string;
  companyName: string;
}

export interface GetAllColumnDetailsResponse {
  allColumnDetails: Array<ColumnDetails>;
}

export interface ColumnDetailsBase {
  column: Column;
  key: ColumnKeys;
  columnName: string;
  type: ColumnType;
  values?: Array<ColumnValue>;
  editingDisabled?: boolean;
}

export interface ColumnDetails extends ColumnDetailsBase {
  removable: boolean;
  canCopyContent?: boolean;
}

export interface ColumnValue {
  label: string;
  value: number | string;
}

export enum ColumnKeys {
  CATEGORY = 'category',
  DETAILS = 'details',
  COMMAND_LINE = 'commandLine',
  ACTION_TAKEN = 'actionTaken',
  THREAT_TYPE = 'threatType',
  DEVICE_NAME = 'deviceName',
  IP = 'ip',
  ENDPOINT_TYPE = 'endpointType',
  LAST_DETECTED = 'lastDetectedOn',
  USER = 'user',
  DETECTING_MODULE = 'detectingModule',
  DETECTING_TECHNOLOGY = 'detectingTechnology',
  MALWARE_NAME = 'malwareName',
  FILELESS_ATTACK = 'filelessAttack',
  // This field is not used yet. When it will be, it sould also be added to default column widths
  INSERTED_AT = 'insertedAt',
  HOST_NAME = 'hostName',
  SHA_256 = 'sha256',
  COMPANY = 'company',
  TAGS = 'tags',
}

export enum ColumnsOrder {
  CATEGORY = 0,
  DETAILS = 1,
  COMMAND_LINE = 2,
  ACTION_TAKEN = 3,
  THREAT_TYPE = 4,
  DEVICE_NAME = 5,
  TAGS = 6,
  COMPANY = 7,
  IP = 8,
  ENDPOINT_TYPE = 9,
  LAST_DETECTED = 10,
  USER = 11,
  DETECTING_MODULE = 12,
  DETECTING_TECHNOLOGY = 13,
  MALWARE_NAME = 14,
  FILELESS_ATTACK = 15,
  SHA_256 = 16,
  HOST_NAME = 17,
}

export interface InitAlertsResponse {
  isPartner: boolean;
  views: Array<ViewConfiguration>;
  allColumns: Array<ColumnDetails>;
  activeViewId: string;
  // Default view properties, i.e., that will be used when the user opens the view
  // for the first time. Used to restore a view to its default properties.
  defaultViewProps: ViewConfiguration;
  viewsPanelOpen: boolean;
  allDirectManagement?: Array<string>;
}

export interface BaseViewConfiguration {
  name: string;
  type: ViewType;
  filters: Array<Filter>;
  displayedColumns: Array<Column>;
  compactView: boolean;
  pageSize: number;
  columnConfigs?: Array<AlertsColumnConfiguration>;
  isShared?: boolean;
}

export interface CreateViewConfiguration extends BaseViewConfiguration {}

export interface ViewConfiguration extends BaseViewConfiguration {
  id: string;
}

export interface AlertsColumnConfiguration extends GridColumnConfiguration {}

export interface SetFiltersResponse {}

export interface UpdateSettingsResponse {
  columnConfigs?: Array<AlertsColumnConfiguration>;
}
